import { stringToObject } from "src/legacy/utils/helpers";
import { TherapistClientProfileSections } from "../constants";

function getSectionData(
    profileDetails: any,
    categoryId: string,
    pageId: string
) {
    const sectionCategory =
        profileDetails?.length &&
        profileDetails?.filter(
            (category: any) =>
                category?.frontend_identifier === categoryId ||
                category?.unique_key === categoryId ||
                categoryId?.includes(category.frontend_identifier)
        );

    if (sectionCategory?.length) {
        return sectionCategory[0]?.pages.filter(
            (page: any) =>
                page?.frontend_identifier === pageId ||
                pageId?.includes(page?.frontend_identifier)
        )[0];
    }
}

function getSectionDataV1(
    profileDetails: any,
    categoryId: string,
    pageId: string,
    QuestionId: any,
    isMetaData?: boolean,
    secondSection?: string,
) {
    let sectionFinalData = {};

    const sectionCategory =
        profileDetails?.length &&
        profileDetails?.filter(
            (category: any) =>
                category?.frontend_identifier === categoryId ||
                category?.unique_key === categoryId ||
                categoryId?.includes(category?.frontend_identifier)
        );

    const sectionPageData =
        sectionCategory?.length &&
        sectionCategory[0]?.pages?.filter(
            (page: any) =>
                page?.frontend_identifier === pageId ||
                page?.unique_key === pageId ||
                pageId?.includes(page?.frontend_identifier) ||
                pageId?.includes(page?.unique_key)
        );

    const sectionQuestion =
        sectionPageData?.length &&
        sectionPageData[0]?.questions?.filter(
            (question: any) =>
                question?.frontend_identifier === QuestionId ||
                question?.unique_key === QuestionId ||
                QuestionId.includes(question?.frontend_identifier) ||
                QuestionId.includes(question.unique_key)
        );

    const selectedValues: any = [];

    if (!isMetaData) {
        sectionQuestion?.length &&
            sectionQuestion[0]?.choices
                ?.filter((choice: any) => choice.selected)
                .forEach((selectedChoice: any) => {
                    switch (selectedChoice?.title) {
                        case "Date of Birth":
                            selectedValues.push(selectedChoice?.value);

                            return;
                        default:
                            selectedValues.push(
                                selectedChoice.display_title ||
                                    selectedChoice.title ||
                                    selectedChoice?.value
                            );
                    }
                });
    } else {
        const question =
            sectionPageData?.length &&
            sectionPageData[0]?.questions?.filter((question: any) =>
                !secondSection
                    ? question?.choices[0]?.selected
                    : question?.choices[0]?.selected &&
                      question?.frontend_identifier === QuestionId
            );

        question?.forEach((element: any) => {
            if (element.choices[0].value) {
                const metadataObj = stringToObject(element.choices[0].metadata);
                const data = {
                    ...element,
                    ...element.choices[0],
                    metadata: metadataObj,
                };

                selectedValues.push(data);
            }
        });
    }

    if (sectionPageData?.length) {
        sectionFinalData = {
            title:
                sectionQuestion[0]?.display_title ||
                sectionQuestion[0]?.title ||
                "",
            value:
                selectedValues?.length === 1 ? selectedValues : selectedValues,
        };

        return sectionFinalData;
    }
}

// Matching Priority Mapping
function getMatchingPriority(profileDetails: any) {
    const wantToUseInsuranceSectionData: any = getSectionDataV1(
        profileDetails,
        TherapistClientProfileSections?.insurance?.categories_identifier,
        TherapistClientProfileSections?.insurance?.pageIdentifier,
        TherapistClientProfileSections?.insurance?.question_identifier
    );
    const wantToUseInsuranceTitle = wantToUseInsuranceSectionData?.value[0];

    const matchingPrioritySectionData: any = getSectionDataV1(
        profileDetails,
        TherapistClientProfileSections?.matchingPriority?.categories_identifier,
        TherapistClientProfileSections?.matchingPriority?.pageIdentifier,
        TherapistClientProfileSections?.matchingPriority?.question_identifier
    );
    const matchingPriorityTitle = matchingPrioritySectionData?.value[0];

    // TODO : Scenario Testing On dev
    let mPriorityTitle = "";

    if (
        (wantToUseInsuranceTitle ===
            "No, I don't have or want to use insurance" &&
            matchingPriorityTitle ===
                "Finding a therapist who is the best fit is my top priority") ||
        (wantToUseInsuranceTitle ===
            "I prefer in-network but am open to out-of-network" &&
            matchingPriorityTitle ===
                "Finding a therapist who is the best fit is my top priority")
    ) {
        mPriorityTitle = "Best match is more important than affordability";
    } else if (
        (wantToUseInsuranceTitle ===
            "I prefer in-network but am open to out-of-network" &&
            matchingPriorityTitle ===
                "Finding a therapist in my budget is my top priority") ||
        (wantToUseInsuranceTitle ===
            "No, I don't have or want to use insurance" &&
            matchingPriorityTitle ===
                "Finding a therapist in my budget is my top priority")
    ) {
        mPriorityTitle = "Affordability is more important than best match";
    } else if (
        wantToUseInsuranceTitle === "Yes, I need an in-network therapist"
    ) {
        mPriorityTitle = "I need a therapist who takes my insurance";
    }

    return mPriorityTitle;
}

export { getSectionData, getSectionDataV1, getMatchingPriority };
